var windowWidth = window.innerWidth;
var lazyImages = document.querySelectorAll('img.lazy');
var lazyIframe = document.querySelectorAll('iframe.lazy');
var flag = true;

function isScriptAlreadyIncluded(t) {
	for(var e=document.getElementsByTagName("script"),r=0;r<e.length;r++)
		if(e[r].getAttribute("src")==t)return!0;
	return!1
}
function checkDeleteImages() {
	checkDeleteImages = document.querySelectorAll('img');
	checkDeleteImages.forEach(image => {
		if( image.src == "" && image.dataset.src == "" ) image.remove();
	});
}
function lazyLoadImg() {
	lazyImages.forEach(image => {
		var bounding = image.getBoundingClientRect();
		if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= window.innerWidth && bounding.bottom <= window.innerHeight)
		{
			src = image.dataset.lazysrc;
			if( src != null )
				image.src = src;
		}
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(value => {
		datasrc = value.dataset.src;
		if( datasrc != null )
			value.src = datasrc;
	});
}
function lazyLoadCss(url) {
	var s=document.createElement("link");
	s.rel="stylesheet",s.href=url;
	var x=document.getElementsByTagName("head")[0];
	x.appendChild(s);
}
function lazyLoadJS(url) {
	if( !isScriptAlreadyIncluded(url) ) {
		var s=document.createElement("script");
		s.type="text/javascript",s.async=!0,s.src=url;
		var x=document.getElementsByTagName("head")[0];
		x.appendChild(s);
	}
}
document.addEventListener("DOMContentLoaded", function() {
	lazyLoadImg();
	jQuery("#shopify-section-1536356474398").find("img.lazy").each(function( index ) {
		src = $( this ).data("lazysrc");
		if( src != null )
			jQuery( this ).attr("src", src);
	});
});
window.addEventListener("scroll", function(event) {
	lazyLoadImg();
	if(flag) {
		lazyLoadIframe();
		load_all_js();
		flag = false;
	}
});
window.addEventListener("mousemove", function(event) {
	lazyLoadImg();
	if(flag) {
		lazyLoadIframe();
		load_all_js();
		flag = false;
	}
});
window.addEventListener("touchstart", function(event) {
	lazyLoadImg();
	if(flag) {
		lazyLoadIframe();
		load_all_js();
		flag = false;
	}
});
function asyncLoad() {
	var urls = ["\/\/staticw2.yotpo.com\/7LY5zwiaDxaOFF0jsTOLI6Z9CusN2mBC7Q6RLwqc\/widget.js?shop=natures-guru.myshopify.com","https:\/\/chimpstatic.com\/mcjs-connected\/js\/users\/7450353cb48e365e0d75b26ab\/ed9fcb6f49b7acbdc07ea5c95.js?shop=natures-guru.myshopify.com","https:\/\/static.rechargecdn.com\/static\/js\/recharge.js?shop=natures-guru.myshopify.com","https:\/\/intg.snapchat.com\/shopify\/shopify-scevent.js?id=abfebbd9-b627-43e5-a6b3-91b08e0bd207\u0026shop=natures-guru.myshopify.com","https:\/\/bingshoppingtool-t2app-prod.trafficmanager.net\/uet\/tracking_script?shop=natures-guru.myshopify.com","https:\/\/cdn.shopifycloud.com\/messenger_commerce\/assets\/new_message_us?version=1584940135\u0026page_id=251987108651\u0026color=blue\u0026size=large\u0026position_horizontal=right\u0026position_vertical=bottom\u0026messenger_app_id=1163199097047119\u0026shop=natures-guru.myshopify.com","https:\/\/cdn.ravenjs.com\/3.26.2\/raven.min.js?shop=natures-guru.myshopify.com","https:\/\/static.klaviyo.com\/onsite\/js\/klaviyo.js?company_id=LVUubK\u0026shop=natures-guru.myshopify.com","https:\/\/static.klaviyo.com\/onsite\/js\/klaviyo.js?company_id=LVUubK\u0026shop=natures-guru.myshopify.com","https:\/\/static.klaviyo.com\/onsite\/js\/klaviyo.js?company_id=LVUubK\u0026shop=natures-guru.myshopify.com","https:\/\/www.magisto.com\/media\/shopify\/magisto.js?shop=natures-guru.myshopify.com","https:\/\/cdn.refersion.com\/shop.js?key=pub_7731de86665c86da88e1\u0026check_token=true\u0026shop=natures-guru.myshopify.com","https:\/\/orderlookup.hulkapps.com\/js\/order-lookup-by-hulkapps.js?shop=natures-guru.myshopify.com","https:\/\/d2oc6krkhhy4rs.cloudfront.net\/scripts\/script-natures-guru-1587982593.js?shop=natures-guru.myshopify.com","https:\/\/s3.amazonaws.com\/lastsecondcoupon\/js\/freeshippingbar.js?shop=natures-guru.myshopify.com"];

	for (var i = 0; i < urls.length; i++) {
		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = urls[i];
		var x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}
}
function load_all_js() {

/*
	!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s)}(window, document,'script',
	'https://connect.facebook.net/en_US/fbevents.js');
	fbq('init', '{your-pixel-id-goes-here}');
	fbq('track', 'PageView');
*/

	(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/7LY5zwiaDxaOFF0jsTOLI6Z9CusN2mBC7Q6RLwqc/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();

	jQuery("body").css("background-image","");
	jQuery("body").css("background-image","");

	jQuery('.instagram-feed-wrap').each(function (index, value) {
		var $target = jQuery(this).find(".js-instafeed");
		instagram.loadContent({
			el: $target,
			clientID: $target.data('client-id'),
			limit: $target.data('count')
		});
	});

	asyncLoad();

	lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/load_feature-0706a8295b35d60f33df1284f223480aff1cbe7c9b26437e4ccb6937d858ea0e.js");
	lazyLoadJS("https://cdn.shopify.com/s/assets/shopify_pay/storefront-f95c62afca18778ed8677facd32818c864b5e4938cba1769e8d8ba0b541d41dc.js?v=20190107");
	lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/features-118a698fb45bb1e2a76ae81b3f81095d1e2c32ced33dd4e93e64378b5eb778d0.js");
	lazyLoadJS("https://cdn.shopify.com/s/assets/themes_support/ga_urchin_forms-99e991855b3d8ddc69e625c68ab0579dd9927b611c2ec4943d396c72e3af0849.js");
}